import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { PlotAttributes } from '~app/models';
import { FieldErrorListComponent } from '../forms/field/field-error-list/field-error-list.component';

export interface IValidatableRendererParams {
  validators: ValidatorFn[];
}

@Component({
  selector: 'ciao-waypoint-name-cell-renderer',
  imports: [NgIf, FieldErrorListComponent],
  template: `
    <div class="waypoint-icon" *ngIf="waypointLabel">
      <div class="waypoint-label">{{ waypointLabel }}</div>
    </div>
    <p>{{ description }}</p>
    <ciao-field-error-list [control]="formControlInput" [forceShow]="true" />
  `,
  styles: `
    :host {
      display:flex;
    }
    .waypoint-icon {
      background: url('/assets/img/icons/map-markers/gray-pin-for-letters.png') no-repeat;
      background-size: 100%;
      width: 25px;
      height: 25px;
      margin-top: 6px;
      margin-right: 10px;
      vertical-align: top;
      flex-shrink: 0;
    }
    .waypoint-label {
      width: fit-content;
      height: 0;
      margin: auto;
      margin-top: 0;
      font-size: 10px;
      font-weight: bold;
      line-height: 1.5;
    }
    p {
      margin: 0;
      line-height: 1.5;
      padding: .5em;
    }
    ciao-field-error-list {
      ::ng-deep ul {
        margin-bottom: 0;
      }
    }
  `,
})
export class WaypointNameCellRenderer implements ICellRendererAngularComp {
  description: string;
  waypointLabel: string;
  validationErrors: string[] = [];
  formControlInput = new FormControl('');

  agInit(
    params: ICellRendererParams<PlotAttributes, any, any> &
      IValidatableRendererParams
  ): void {
    this.formControlInput.addValidators(params.validators);
    this.refresh(params);
  }
  refresh(
    params: ICellRendererParams<PlotAttributes, any, any> &
      IValidatableRendererParams
  ) {
    this.description = params.data?.description;
    this.waypointLabel = params.data?.waypoint?.letter;
    this.formControlInput.setValue(params.data.description);

    return true;
  }
}
